module.exports = __webpack_public_path__ + "img/mafioso-discord-icon.86a4dfdb.gif";